import PropTypes from 'prop-types'
import { useContext, useEffect, useRef } from 'react'
import { useTranslation } from 'next-i18next'

// Internal components
import Button from '../Button/Button'
import { UserContext } from '../../context/UserContext'

const ModalCopylink = (props) => {
  const { input, button } = props
  const inputRef = useRef()

  const userContext = useContext(UserContext)
  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  useEffect(() => {
    inputRef.current.value = window.location.href
  }, [])

  const copyLink = () => {
    const copyText = () => navigator.clipboard.writeText(inputRef?.current?.value)
    const copyTextFallback = () => document.execCommand('copy')

    inputRef?.current?.focus()
    inputRef?.current?.select()
    navigator && navigator?.clipboard ? copyText() : copyTextFallback()
  }

  return (
    <div className="ModalCopylink">
      <label className="ModalCopylink-label" htmlFor="copylink-input">
        {t(input.placeholder)}
      </label>
      <input
        className="ModalCopylink-input"
        type="text"
        placeholder={t(input.placeholder)}
        ref={inputRef}
        name="copylink-input"
        id="copylink-input"
      />
      <Button label={t(button.label)} modifiers={['Button--modalCopylink']} onClick={copyLink} />
    </div>
  )
}

ModalCopylink.propTypes = {
  input: PropTypes.object,
  button: PropTypes.object
}

export default ModalCopylink
